module.exports = __webpack_public_path__ + "img/19800.cb7ddafb.jpg";